var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Alert, Button, Chip, DialogActions, DialogContent, DialogTitle, LinearProgress, TextField } from "@mui/material";
import { Dialog2 } from "../../../../misc/Dialog2";
import React, { Suspense, useRef, useState } from "react";
import { useAsyncAction } from "nate-react-api-helpers";
import { api } from "../../../../api/API";
import { grey } from "@mui/material/colors";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const EditScriptField = /*#__PURE__*/ React.lazy(() => import("./EditScriptField").then(f => ({ default: f.EditScriptField })));
export function EditScript(props) { return /*#__PURE__*/ _jsx(Suspense, { fallback: /*#__PURE__*/ _jsx(LoadingEl, {}), children: /*#__PURE__*/ _jsx(EditScriptInner, Object.assign({}, props)) }); }
function EditScriptInner(props) {
    const [name, setName] = useState(props.value.name); // don't re-render for code to avoid re-creating EditScriptField every time
    const codeRef = useRef(props.value.script || blankScript);
    const check = useAsyncAction((input) => __awaiter(this, void 0, void 0, function* () { const rs = yield api.products.checkScript({ script: input.code }); if (rs.status === "ok") {
        if (input.onDone) {
            input.onDone();
        }
    } return rs; }), []);
    const checkR = check.result;
    console.log("checkR?.status", checkR === null || checkR === void 0 ? void 0 : checkR.status);
    const submit = () => { if (name.length < 4)
        return; const code = codeRef.current; check.callback({ code: code, onDone: () => { props.onSave(Object.assign({}, props.value, { name: name, script: codeRef.current })); props.onClose(); } }); };
    return /*#__PURE__*/ _jsxs(Dialog2, { open: true, onClose: () => props.onClose(), maxWidth: "xl", fullWidth: true, onEnterPress: submit, children: [/*#__PURE__*/ _jsx(DialogTitle, { children: "Edit Script" }), /*#__PURE__*/ _jsxs(DialogContent, { children: [/*#__PURE__*/ _jsx("div", { style: { height: 8 } }), /*#__PURE__*/ _jsx(TextField, { label: "Name", value: name, onChange: e => { let value = e.currentTarget.value; value = value.replace(/[^A-z_]+/g, ""); setName(value); }, helperText: "e.g. sku_handing (no spaces or special characters)" }), /*#__PURE__*/ _jsxs("div", { style: { display: "flex", flexDirection: "row", alignItems: "flex-start", gap: 8, width: "100%" }, children: [/*#__PURE__*/ _jsxs("div", { style: { display: "flex", flex: 1, flexDirection: "column" }, children: [/*#__PURE__*/ _jsx(EditScriptField, { value: codeRef.current, onChange: v => { codeRef.current = v; } }, "main"), (checkR === null || checkR === void 0 ? void 0 : checkR.status) === "error" && /*#__PURE__*/ _jsxs(Alert, { style: { marginTop: 8 }, severity: "error", children: [checkR.line > 0 && /*#__PURE__*/ _jsxs("div", { children: [checkR.line, " ", checkR.context] }), /*#__PURE__*/ _jsx("div", { children: checkR.detail })] })] }), /*#__PURE__*/ _jsx("div", { style: { width: 400, display: "flex", opacity: 0.7 }, children: /*#__PURE__*/ _jsx(EditScriptField, { value: demoCode }, "demo") })] })] }), /*#__PURE__*/ _jsxs(DialogActions, { children: [/*#__PURE__*/ _jsx(Button, { onClick: () => { check.callback({ code: codeRef.current }); }, children: "Check Code" }), (checkR === null || checkR === void 0 ? void 0 : checkR.status) === "error" ? /*#__PURE__*/ _jsx(Chip, { color: "error", label: "See error above" }) : (checkR === null || checkR === void 0 ? void 0 : checkR.status) === "ok" ? /*#__PURE__*/ _jsx(_Fragment, { children: /*#__PURE__*/ _jsx(Chip, { color: "success", label: "Code is ok" }) }) : null, check.LoadingElement, /*#__PURE__*/ _jsx("div", { style: { flex: 1 } }), /*#__PURE__*/ _jsx(Button, { onClick: () => props.onClose(), children: "Cancel" }), /*#__PURE__*/ _jsx(Button, { disabled: name.length < 4, onClick: submit, children: "Update" })] })] });
} // fields:
// "nominal.width"
// "nominal.height"
// "inactive.width"
// "opening.type"
// "opening.subType"
// "opening.handing"
// "opening.qty"
// "qty"
// "opening.flipDoubleActiveHanding"
// "handing"
// "door.handing"
// "door.width"
// "door.height"
// "door.thickness"
// "frame.profile"
// "frame.jambDepth"
// "frame.width"
// "frame.height"
// "frame.anchorQtyOverride"
const blankScript = `if handing = LH
    return L2

error: invalid handing`;
const demoCode = `# Example code

# variables:
# door.width, door.height, door.thickness, door.handing
# frame.width, frame.height, frame.jambDepth, frame.profile
# nominal.width, nominal.height
# qty
# label
# opening.type, opening.subType, opening.handing, opening.qty, opening.flipDoubleActiveHanding

# compare things
if nominal.width = 4'2 11/16 or nominal.width < 2'0 or nominal.width >= 5'0
  return EXT # output EXT
  
if label = 20 min
  return nominal.width * 2 # do math *, /, +, -

# use metric or imperial inter-changably
if nominal.height < 1000mm
  # use max/min functions to limit values to a certain range
  return min(max(nominal.height, 1000mm), 2000mm)
  
# trigger errors
if isblank(handing) 
  error: invalid width, should be over 2'0

if handing = RHR
  return LH

if handing = LH
  return LH

# do complicated math
return 5 * 2'0 + 7 / nominal.width - 200mm`;
function LoadingEl() { return /*#__PURE__*/ _jsx("div", { style: { color: grey["200"] }, children: /*#__PURE__*/ _jsx(LinearProgress, {}) }); }
